<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import Button from "@components/Buttons/Button.svelte";

    export let title: string;
    export let withIcon = true;
    export let actionText: string | undefined = undefined;

    const dispatch = createEventDispatcher();

    const handleAction = () => {
        dispatch("action");
    };
</script>

<div class="gw-rv-empty-list">
    <div class="gw-rv-empty-list__header">
        {#if withIcon}
            <slot name="icon" />
        {/if}
        <p class="gw-rv-empty-list__header-title">{title}</p>
    </div>

    {#if actionText}
        <Button
            class="gw-rv-empty-list__action-button"
            variant="link"
            on:click={handleAction}
        >
            {actionText}
        </Button>
    {/if}
</div>

<style lang="postcss">
    .gw-rv-empty-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5em;
        padding: 1em 0;

        &__header {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.5em;

            &-title {
                color: #979faf;
                font-size: 1em;
                font-weight: 400;
                line-height: 1.2em;
            }
        }
    }

    :global(.gw-btn.gw-button.gw-rv-empty-list__action-button) {
        color: #3772ff;
        font-size: 0.9em;
    }
</style>
